export enum TermTypes {
  Trimester = 1,
  Semester = 2,
}

export function getTermTypeName(value: TermTypes): string {
  switch (value) {
    case TermTypes.Trimester: return '３学期制';
    case TermTypes.Semester: return '前後期制';
  }
}
